export const SearchConfig = {
  reachProp: 'alcance',
  searchProp: 'criterio',
  grouperProp: 'agrup',
  liquidationProp: 'liqui',
};
